// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Çeviri Yönetimi',
  subtitle: 'Uygulama çevirilerini yönetin',
  fileBasedSubtitle: 'Dosya tabanlı çeviri editörü',
  
  // Bilgi mesajları
  infoText: 'Çeviriler src/locales/ dizini altındaki dosyalarda saklanır.',
  fileBasedInfo: 'Dosya Tabanlı Çeviri Sistemi',
  fileBasedInfoHint: 'Çevirileri doğrudan dosyalarda düzenleyin. Değişikliklerin etkili olması için sayfayı yenilemeniz gerekir.',
  
  // Dil seçimi
  selectLanguage: 'Dil Seçin',
  
  // Arama
  searchTranslations: 'Çeviri ara...',
  
  // Dosya yönetimi
  translations: 'çeviri',
  noTranslationsFound: 'Çeviri bulunamadı',
  noFilesFound: 'Çeviri dosyası bulunamadı',
  noFilesFoundHint: 'Locale dosyalarının src/locales/ dizininde olduğundan emin olun',
  
  // Düzenleme modu
  editMode: 'Düzenleme Modu',
  viewMode: 'Görüntüleme Modu',
  
  // Kaydetme bildirimleri
  saveNotice: 'Demo Modu',
  saveNoticeHint: 'Production\'da bu dosya sunucu tarafında kaydedilecek. Şimdilik dosya içeriği için konsolu kontrol edin.',
  fileContentReady: 'Dosya içeriği oluşturuldu! Çıktı için konsolu kontrol edin.',
  
  // Hatalar
  loadError: 'Çeviriler yüklenemedi',
  saveError: 'Çeviriler kaydedilemedi',
  
  // İşlemler
  editFile: 'Dosyayı Düzenle',
  saveFile: 'Dosyayı Kaydet',
  cancelEdit: 'İptal',
  
  // İstatistikler
  totalFiles: 'Toplam Dosya',
  totalTranslations: 'Toplam Çeviri',
  
  // Dosya kategorileri
  allFiles: 'Tüm Dosyalar',
  common: 'Ortak',
  pages: 'Sayfalar',
  components: 'Bileşenler'
};
